// src/components/Profile/PaymentMethodsSection.js
// Section moyens de paiement (UI statique pour l'instant)

import React from 'react';
import { CreditCard, Plus } from 'lucide-react';
import { WaveLogo, OrangeMoneyLogo } from '../Payment/PaymentMethodLogos';
import './PaymentMethodsSection.css';

const PaymentMethodsSection = () => {
  const paymentMethods = [
    {
      id: 'wave',
      name: 'Wave',
      Logo: WaveLogo,
      description: 'Paiement mobile sécurisé',
      available: true,
    },
    {
      id: 'orange',
      name: 'Orange Money',
      Logo: OrangeMoneyLogo,
      description: 'Paiement via Orange Money',
      available: true,
    },
  ];

  return (
    <div className="payment-section">
      <h2>Moyens de paiement</h2>
      <p className="section-subtitle">
        Gérez vos moyens de paiement pour régler vos réservations
      </p>

      {/* Liste des moyens */}
      <div className="payment-methods">
        
        {paymentMethods.map((method) => (
          <div key={method.id} className="payment-card">
            <div className="payment-icon payment-icon--logo">
              <method.Logo size={44} />
            </div>

            {/* Info */}
            <div className="payment-info">
              <h3>{method.name}</h3>
              <p>{method.description}</p>
            </div>

            {/* Status */}
            <div className="payment-status">
              {method.available ? (
                <span className="status-badge available">
                  Disponible
                </span>
              ) : (
                <span className="status-badge unavailable">
                  Bientôt
                </span>
              )}
            </div>

          </div>
        ))}

        {/* Ajouter une méthode */}
        <button className="add-payment-btn" disabled>
          <Plus size={24} />
          <span>Ajouter un moyen de paiement</span>
          <span className="coming-soon">Bientôt disponible</span>
        </button>

      </div>

      <div className="payment-notice">
        <CreditCard size={24} color="#3B82F6" />
        <div className="notice-content">
          <h4>Paiement sécurisé</h4>
          <p>
            Tous les paiements sont sécurisés et cryptés. Vos informations 
            bancaires ne sont jamais stockées sur nos serveurs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodsSection;